module.exports = __webpack_public_path__ + "media/scholarship_winners/jacqueline-sw-1512f72f.png";